import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AccountService, FilesService } from '@core/services';
import { DestroyableComponent } from '@models/destroyable.component';
import { User } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnUiCover } from 'onclass-ui';

@Component({
  selector: 'app-onboarding-personal-info',
  templateUrl: './onboarding-personal-info.component.html',
  styleUrls: ['./onboarding-personal-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingPersonalInfoComponent extends DestroyableComponent {
  deviceService = inject(DeviceDetectorService);

  @Input() public user: User;
  @Input() public completed: boolean;

  public isInfoModalOpened: boolean;

  public get userFullName(): string {
    return AccountService.getUserFullName(this.user);
  }

  public get accountRoute(): string {
    return AccountService.accountRoute(this.user).join('/');
  }

  public get isGuest(): boolean {
    return AccountService.isGuest(this.user);
  }

  public get isAsIfTeacher(): boolean {
    return AccountService.isAsIfTeacher(this.user);
  }

  public get avatar(): OnUiCover {
    return {
      type: 'avatar',
      img: FilesService.getFileUrlBySize(this.user?.userpic_id),
      title: this.userFullName,
      link: this.accountRoute,
      form: 'circle',
    };
  }

  public toggleInfoModal() {
    this.isInfoModalOpened = !this.isInfoModalOpened;
  }
}
